import { Dispatch } from "redux";
import { AxnAttributeLabel, AxnAttributeType } from "@idw-types/data/reference-data/axn";
import { addAttributeLabel } from "@redux/actions/attribute-labels-actions";
import { createAxnAttributeLabelRequest } from "@requests/management-console/create-axn-attribute-label";
import { formatAxnAttributeLabel } from "@formatters/axn-attribute-labels/axn-attribute-label-formatter";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const createAttributeLabelReduxRequest = (dispatch: Dispatch) => async (
    axnAttributeLabel: AxnAttributeLabel,
    axnAttributeTypes: Array<AxnAttributeType>
) => {
    const { data, error, body } = await createAxnAttributeLabelRequest(axnAttributeLabel);
    if (data?.response) {
        const formattedAttributeLabel = formatAxnAttributeLabel(data.response, axnAttributeTypes);
        dispatch(addAttributeLabel(formattedAttributeLabel));
        displaySuccessModal(
            dispatch,
            resources.requests.createAttributeLabel.success.title,
            resources.requests.createAttributeLabel.success.message
        );
        return data.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createAttributeLabel.error.title,
            resources.requests.createAttributeLabel.error.message,
            null,
            null,
            body
        );
    }

    return null;
};